import { render, staticRenderFns } from "./ChangDaokaDataLight.vue?vue&type=template&id=1d1cd7f3&scoped=true"
import script from "./ChangDaokaDataLight.vue?vue&type=script&lang=js"
export * from "./ChangDaokaDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1cd7f3",
  null
  
)

export default component.exports